import { useEffect } from 'react';
import { useGuardedNavigate } from '@/hooks/useUnsavedChangesGuard';
import { NATIVE_OPEN_EVENT, pathForNativeOpen } from '@/lib/native-app';

/**
 * In the phone app, a tapped link or notification opens its page through the unsaved-changes guard
 * (ui-components.project.mdc, "Navigation in code"), like any navigation in code, rather than the app
 * reloading the page and losing edits. Mounted once, inside the router (app.tsx).
 */
export function useNativeAppLinks(): void {
  const guardedNavigate = useGuardedNavigate();
  useEffect(() => {
    const onOpen = (event: Event) => {
      const path = pathForNativeOpen((event as CustomEvent<{ url?: unknown }>).detail?.url, window.location.origin);
      if (!path) return;
      // Taken: the app doesn't load it itself.
      event.preventDefault();
      void guardedNavigate(path);
    };
    window.addEventListener(NATIVE_OPEN_EVENT, onOpen);
    return () => window.removeEventListener(NATIVE_OPEN_EVENT, onOpen);
  }, [guardedNavigate]);
}
